'use client';

import { Tab } from '@brand-order/web-ui';
import { usePathname, useRouter } from 'next/navigation';
import FIND_ACCOUNT_TAB_LIST from './_constants/findAccountTabList';
import PATHS from '@/constants/path';
import cn from '@/utils/cn';

const TAB_PATH_MAP: Record<number, string> = {
  1: PATHS.AUTH.FIND_ACCOUNT.FIND_ID,
  2: PATHS.AUTH.FIND_ACCOUNT.FIND_PW,
};

export default function FindAccountLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();

  // 전화번호 기반 레거시 아이디 찾기는 독립 풀페이지 SMS 인증 화면(PhoneStep/OtpStep)을 그대로 쓰므로
  // ID/PW 탭·중앙 컨테이너 크롬을 씌우지 않는다.
  const isLegacyFindIdFlow = pathname.startsWith(PATHS.AUTH.FIND_ACCOUNT.FIND_ID_LEGACY);

  const activeTab = pathname.startsWith(PATHS.AUTH.FIND_ACCOUNT.FIND_PW) ? 2 : 1;

  if (isLegacyFindIdFlow) {
    return <div className="bg-white">{children}</div>;
  }

  const handleTabChange = ({ value }: { value: number }) => {
    const path = TAB_PATH_MAP[value];
    if (path) router.replace(path);
  };

  return (
    <div className="bg-white">
      <div
        className={cn(
          'mx-auto flex w-full max-w-150 flex-col items-center px-7.5 desktop:px-0 py-5 desktop:py-10',
          activeTab === 1 ? 'gap-25 desktop:gap-20' : 'gap-15',
        )}
      >
        <Tab
          itemList={FIND_ACCOUNT_TAB_LIST}
          value={activeTab}
          onChange={handleTabChange}
          mobileSize="medium"
          tabletSize="medium"
          desktopSize="large"
        />
        {children}
      </div>
    </div>
  );
}
